<template>
    <div class="http-upload">
        <HeaderNav
            header-title="原生上传测试"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="content">
            <van-field
                label-width="55%"
                label="maxNum"
                input-align="right"
                v-model="opt.maxNum"
                type="number"
            ></van-field>
            <van-field
                label-width="55%"
                label="fileType"
                input-align="right"
                v-model="opt.fileType"
                type="number"
            ></van-field>
            <van-field
                label-width="55%"
                label="albumSelection"
                input-align="right"
            >
                <template #input>
                    <van-switch v-model="opt.albumSelection" size="20"></van-switch>
                </template>
            </van-field>
            <van-field
                label-width="55%"
                label="showCameraBtn"
                input-align="right"
            >
                <template #input>
                    <van-switch v-model="opt.showCameraBtn" size="20"></van-switch>
                </template>
            </van-field>
            <van-field
                label-width="55%"
                label="videoMaxSecond"
                input-align="right"
                v-model="opt.videoMaxSecond"
                type="number"
            ></van-field>
            <van-field
                label-width="55%"
                label="addWatermarkType"
                input-align="right"
                v-model="opt.addWatermarkType"
            ></van-field>
            <van-field
                label-width="55%"
                label="watermarkInfo.otherInfo"
                input-align="right"
                v-model="opt.watermarkInfo.otherInfo"
            ></van-field>
            <van-field
                label-width="55%"
                label="watermarkInfo.time"
                input-align="right"
                v-model="opt.watermarkInfo.time"
            ></van-field>
            <van-field
                label-width="55%"
                label="watermarkInfo.address"
                input-align="right"
            >
                <template #input>
                    <van-switch v-model="opt.watermarkInfo.address" size="20"></van-switch>
                </template>
            </van-field>
            <van-field
                label-width="55%"
                label="watermarkInfo.coordinate"
                input-align="right"
            >
                <template #input>
                    <van-switch v-model="opt.watermarkInfo.coordinate" size="20"></van-switch>
                </template>
            </van-field>
            <van-field
                label-width="55%"
                label="watermarkInfo.color"
                input-align="right"
                v-model="opt.watermarkInfo.color"
            ></van-field>
            <div class="btns" style="text-align: center;padding: 20px">
                <van-button
                    round
                    block
                    type="info"
                    @click="upload"
                >
                    上传
                </van-button>
            </div>
            <div class="title" style="padding: 10px">
                文件列表- <a style="color: blue" @click="clearFiles">清空文件</a>
            </div>
            <div class="file-list">
                <template v-if="opt.fileType==1">
                    <van-uploader
                        preview-image
                        preview-full-image
                        v-model="fileList"
                        multiple
                        upload-icon="plus"
                        @click-upload="upload"
                        :readonly="true"
                        :show-upload="false"
                    ></van-uploader>
                </template>
                <template v-if="opt.fileType==2">
                    <van-uploader
                        :preview-full-image="false"
                        accept="video/*"
                        v-model="fileList"
                        multiple
                        upload-icon="plus"
                        @click-upload="upload"
                        :readonly="true"
                        :show-upload="false"
                    >
                        <template #preview-cover="file">
                            <div :class="['preview-cover']">
                                <video
                                    class="pover-video"
                                    @click="previewVideo(file)"
                                >
                                    <source :src="file.url" type="video/mp4">
                                    <source :src="file.url" type="video/ogg">
                                    <source :src="file.url" type="video/webm">
                                    <source :src="file.url" type="video/quicktime">
                                </video>
                            </div>
                        </template>
                    </van-uploader>
                    <previewVideo :visible.sync="showPreviewVideo" :url="previewVideoUrl"></previewVideo>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import JYExternalNative from '@/assets/js/JYExternalNative.js';
import { HeaderNav } from '@/components/';
import previewVideo from '@/components/video/previewVideo';
export default {
    name: 'http-upload',
    components: {
        HeaderNav, previewVideo,
    },
    data() {
        return {
            opt: {
                maxNum: 3, // 最大上传个数
                fileType: 1, // 文件类型：0全部，1图片，2，视频
                albumSelection: true, //  true从相册选择，false直接拍照or录像
                showCameraBtn: true, // 相册选择是否展示 拍照按钮
                videoMaxSecond: 15, // 录像or选视频 最大秒数
                addWatermarkType: 2, // 加水印，0或null不加，1仅拍照、录像加，2拍照、录像、相册选择的都加
                watermarkInfo: {
                    otherInfo: '666666666', // 水印文字信息
                    time: 'yyyy-MM-dd HH:mm:ss', // 水印时间
                    address: true, // 水印是否显示水印地址
                    coordinate: true, // 水印是否显示经纬度
                    color: '#D9D1C0', // 水印颜色
                },
            },
            fileList: [],
            showPreviewVideo: false,
            previewVideoUrl: '',
        };
    },
    created() {
        const opt = {
            dataId: 'testHttpUpload',
            code:'ProductionAffix',
            tenant_id: this.$takeTokenParameters('TenantId'),
        }
    },
    methods: {
        async upload() {
            this.previewVideoUrl = '';

            this.opt.maxNum = Number(this.opt.maxNum);
            this.opt.fileType = Number(this.opt.fileType);
            this.opt.videoMaxSecond = Number(this.opt.videoMaxSecond);
            this.opt.addWatermarkType = Number(this.opt.addWatermarkType);
            alert(JSON.stringify(this.opt));
            const res = await JYExternalNative.$chooseFileHttpUpload(this.opt);
            alert(res);
            const { DataContext } = JSON.parse(res);

            if (this.opt.fileType == 1) {
                const urls = DataContext.map(fileId => {
                    const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${fileId.Id}/download`;
                    return { url: url, isImage: true, fileId: fileId };
                });
                this.fileList = urls;
            } else {
                const urls = DataContext.map(fileId => {
                    const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${fileId.Id}/download`;
                    return { url: url, isImage: false, fileId: fileId };
                });
                this.fileList = urls;
            }
        },
        async clearFiles() {
            // 通过filegroupinstance获取文件列表并删除
            const dataId = this.opt.dataId || 'testHttpUpload';
            const url = `/interfaceApi/basicplatform/simpleflow/filegroupinstance/${dataId}`;
            const files = await this.$axios.get(url);
            if (files && files.length > 0) {
                files.forEach(item => {
                    this.$axios.delete(`${this.GLOBAL.FILE_BASE_URL}file-manage/${item.AFI_Code}`);
                });
            }
            this.fileList = [];
        },
        // 预览视频
        previewVideo(file) {
            this.previewVideoUrl = file.url;
            this.showPreviewVideo = true;
        },
    },
};
</script>

<style lang="stylus" scoped>
.http-upload
    padding-top 45rpx
    height:100%;
    .content
        height 100%;
        overflow-y auto
    .file-list
        padding 0 20rpx 20rpx
        display flex
        align-items flex-end
        .van-uploader__file
            width 72rpx
            height 72rpx
        .van-uploader__file-name
            display none;
        .van-uploader__preview-cover
            overflow hidden
            display: flex;
            justify-content: center;
            align-items: center;
            .preview-cover
                width 100%
                height 100%
                overflow hidden
                .pover-video
                    width 100%
                    height 100%
                    object-fit cover
</style>
